/**
 * Custom Charm Selector - Versione Finale
 * Gestisce la visualizzazione condizionale dei charm in base alle varianti selezionate
 */

(function() {
  'use strict';

  class CharmSelector {
    constructor() {
      this.charmConfigurations = [
        {
          optionValue: 'personaggi',
          optionIndices: [0, 1, 2],
          required: true,
          containerClass: 'scegli-il-charm-personaggi0-1-2'
        },
        {
          optionValue: 'forme',
          optionIndices: [0, 1, 2],
          required: true,
          containerClass: 'scegli-il-charm-forme0-1-2'
        },
        {
          optionValue: 'veicoli',
          optionIndices: [0, 1, 2],
          required: true,
          containerClass: 'scegli-il-charm-veicoli0-1-2'
        }
      ];

      this.productFormId = null;
      this.init();
    }

    init() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setup());
      } else {
        this.setup();
      }
    }

    setup() {
      // Rimuovi novalidate da tutti i form (con controllo null)
      const forms = document.querySelectorAll('form[novalidate]');
      forms.forEach(form => {
        if (form) {
          form.removeAttribute('novalidate');
        }
      });

      // Ottieni l'ID del form prodotto
      this.productFormId = this.getProductFormId();

      // Esegui il check iniziale
      this.checkCurrentOptions();

      // Ascolta i cambiamenti sulla variante (con controllo null)
      const variantInput = document.querySelector('.product-variant-id');
      if (variantInput) {
        variantInput.addEventListener('change', () => this.checkCurrentOptions());
      }

      // Ascolta i cambiamenti sui select/radio delle varianti
      const variantSelects = document.querySelectorAll('variant-selects select, variant-selects input[type="radio"]');
      variantSelects.forEach(element => {
        element.addEventListener('change', () => {
          // Piccolo delay per permettere al DOM di aggiornarsi
          setTimeout(() => this.checkCurrentOptions(), 50);
        });
      });

      // Ascolta anche gli eventi PUB_SUB se disponibili
      if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.variantChange) {
        subscribe(window.PUB_SUB_EVENTS.variantChange, () => {
          this.checkCurrentOptions();
        });
      }
    }

    getProductFormId() {
      const productForm = document.querySelector('product-form');
      if (!productForm) return null;

      const sectionId = productForm.dataset.sectionId;
      return sectionId ? `product-form-${sectionId}` : null;
    }

    sanitizeClassName(str) {
      return str
        .replace(/[^a-zA-Z0-9\s]/g, '')
        .replace(/\s+/g, '-')
        .toLowerCase();
    }

    getCurrentVariantValues() {
      const variantSelects = document.querySelector('variant-selects');
      if (!variantSelects) return [];

      const selectedOptions = variantSelects.querySelectorAll(
        'select option[selected], fieldset input:checked'
      );
      return Array.from(selectedOptions).map(el => el.value);
    }

    checkCurrentOptions() {
      const currentValues = this.getCurrentVariantValues();

      this.charmConfigurations.forEach(config => {
        this.processCharmConfiguration(config, currentValues);
      });
    }

    processCharmConfiguration(config, currentValues) {
      const { optionValue, optionIndices, required, containerClass } = config;

      // Verifica se questa configurazione deve essere mostrata
      const shouldDisplay = optionIndices.some(optionIndex => {
        return (
          currentValues[optionIndex] !== undefined &&
          this.sanitizeClassName(currentValues[optionIndex]) === optionValue
        );
      });

      // Trova tutti i container con questa classe
      const containers = document.querySelectorAll(`.${containerClass}`);
      if (containers.length === 0) return;

      // Trova tutti gli input in questi container
      const inputs = document.querySelectorAll(`.${containerClass} input[type="radio"]`);

      // Mostra/nascondi i container
      containers.forEach(container => {
        container.style.display = shouldDisplay ? 'block' : 'none';
      });

      // Gestisci gli attributi degli input
      inputs.forEach(input => {
        if (shouldDisplay && this.productFormId) {
          input.setAttribute('form', this.productFormId);
          if (required) {
            input.setAttribute('required', 'required');
          }
        } else {
          input.setAttribute('form', '');
          input.removeAttribute('required');
          // Deseleziona l'input se la sezione è nascosta
          if (input.checked) {
            input.checked = false;
          }
        }
      });

      // Gestisci anche eventuali input nascosti per file upload
      const fileUploadInputs = document.querySelectorAll('.hidden-input-fileupload');
      fileUploadInputs.forEach(input => {
        if (shouldDisplay && this.productFormId) {
          input.setAttribute('form', this.productFormId);
        } else {
          input.setAttribute('form', '');
        }
      });
    }
  }

  // Inizializza il charm selector
  new CharmSelector();
})();
